module.exports = function($) {
    $(document).ready(function() {

        // if(typeof bannerAnimation !== 'undefined') {
        //     $('.banner.owl-carousel').owlCarousel({
        //         animateIn: (bannerAnimation == 'default' ? '' : bannerAnimation + 'In'),
        //         animateOut: (bannerAnimation == 'default' ? '' : bannerAnimation + 'Out'),
        //         items: 1,
        //         dots: false,
        //         nav: true,
        //         navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
        //         autoHeight: true,
        //         onInitialized: function(e) {
        //             if (!e.namespace) {
        //                 return;
        //             }
        //
        //             // Hide controls if there is only one slide.
        //             if(e.item.count === 1) {
        //                 $(e.target).addClass('no-controls');
        //             }
        //
        //             // Remove loading class.
        //             $(e.target).removeClass('banner-loading');
        //
        //             var slideNumber = (parseInt(e.item.index) + 1);
        //
        //             // Add a span element to display the slide number.
        //             $('<span>' + (slideNumber < 10 ? '0' + slideNumber : slideNumber) +'</span>').insertAfter('.banner.owl-carousel .owl-nav > .owl-prev');
        //         },
        //         onChanged: function(e) {
        //             if (!e.namespace) {
        //                 return;
        //             }
        //
        //             var slideNumber = (parseInt(e.item.index) + 1);
        //
        //             // Update the value of the displayed slide number.
        //             $('.banner.owl-carousel .owl-nav > span').text((slideNumber < 10 ? '0' + slideNumber : slideNumber));
        //         }
        //     })
        // }

    })
}
